import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";  // Import useNavigate
import './welcome_video.css';

const Welcome_video = () => {
    const vidRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/home'); // Redirect to home after 5 seconds
        }, 5000);

        return () => clearTimeout(timer); // Cleanup timeout on unmount
    }, [navigate]);

    return (
        <section className='Welcome_video_sec'>
            <div className='container-fluid p-0'>
                <div className='video_div'>
                    <video className="video"
                        src={process.env.PUBLIC_URL + "/assets/videos/welcome/Welcome_to.mp4"}
                        ref={vidRef}
                        autoPlay
                        muted        // Required for autoplay in most browsers
                        playsInline
                    />
                </div>
            </div>
        </section>
    );
};

export default Welcome_video;
